import { Navigation } from "interfaces/navigation";
import { matchPath } from "react-router-dom";

// A page counts as active on its own path or any child route (e.g.
// friend-center's /shop, /invite), matching how nested routes are set up.
// "/" is the one path that must match exactly, or it'd prefix-match everything.
export const isPageActive = (pathname: string, page: Navigation): boolean =>
	matchPath({ path: page.path, end: page.path === "/" }, pathname) !== null;
